import { useQuery } from '@apollo/client';
import { UserList } from '@bakerweb/models';
import { GET_USERS } from '../graphql/queries/getUsers';

export const useGetUsers = () => {
  const { loading, error, data, refetch } = useQuery<{ users: UserList[] }>(GET_USERS, {
    fetchPolicy: 'cache-and-network'
  });

  const users = data?.users ?? [];

  return { loading, error, users, refetch };
};
